import React from "react";
import axios from "services/axios";
import _ from "lodash";
import { Card, message, Spin, Row } from "antd";
import Lightbox from "react-image-lightbox";

import ApprovalInformation from "../../Component/Section/ApprovalInformation";
import CustomerInformation from "../../Component/Section/CustomerInformationTradeIn";
import SalesInformation from "../../Component/Section/SalesInformation";
import UsedCarInformation from "../../Component/Section/UsedCarInformation";
import NewCarInformation from "../../Component/Section/NewCarInformation";
import RuangNego from "../../Component/Section/RuangNego";
import Discount from "../../Component/Section/Discount";
import GrossProfitAat from "../../Component/Section/GrossProfitAat";
import RequestSection from "../../Component/Section/RequestSection";
import DealSection from "../../Component/Section/DealSection";
import MobbiInformation from "../../Component/Section/MobbiInformation";

import ModalNewCar from "../../Component/Modal/ModalNewCar";
import ModalRequest from "../../Component/Modal/ModalRequest";
import ModalDeal from "../../Component/Modal/ModalDeal";
import ModalNoDeal from "../../Component/Modal/ModalNoDeal";
import { errorMessage } from "../../../../Utils";

class TradeInProgressDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      tradeIn: {},
      request: [],
      newCarList: [],
      reasonNoDealList: [],
      calculation: [],
      finalPrice: 0,
      visibleModalNewCar: false,
      visibleModalRequest: false,
      visibleModalDeal: false,
      visibleModalNoDeal: false,
      visibleModalPhotoAppraisal: false,
      checkButtonSend: false,
      isLoadingButtonSend: false,
      search: "",
      hover: "crosshair",
      typeRequest: "",
    };
    this.visibleModal = this.visibleModal.bind(this);
    this.formatRupiah = this.formatRupiah.bind(this);
    this.getValue = this.getValue.bind(this);
    this.searchNewCar = this.searchNewCar.bind(this);
    this.changeNewCar = this.changeNewCar.bind(this);
    this.changeFinalPrice = this.changeFinalPrice.bind(this);
    this.sendRequestButton = this.sendRequestButton.bind(this);
    this.sendDealButton = this.sendDealButton.bind(this);
    this.sendNoDealButton = this.sendNoDealButton.bind(this);
  }

  componentDidMount() {
    this.fetchTradeIn(this.props.match.params.id);
    this.fetchNewCarList("");
    this.fetchReasonNoDeal();
  }

  // ************************* Function Fetch Data *************************//
  fetchTradeIn(id) {
    this.setState({ isLoading: true });
    axios
      .get(`/admin-panel/trade-in/detail/${id}`)
      .then(result => {
        this.setState({
          tradeIn: result.data.approvalTradeIn,
          request: result.data.approvalRequestStatus,
          calculation: result.data.calculation,
          isLoading: false,
        });
      })
      .catch(err => {
        this.setState({ isLoading: false });
        message.error("Gagal request data trade in");
      });
  }

  fetchNewCarList(search) {
    axios
      .get(`/approval/new-car-list?search=${search}`)
      .then(result => {
        this.setState({
          newCarList: result.data,
        });
      })
      .catch(err => {
        message.error("Gagal request data new car list");
      });
  }

  fetchReasonNoDeal() {
    axios
      .get(`/approval/reason-list`)
      .then(result => {
        this.setState({
          reasonNoDealList: result.data,
        });
      })
      .catch(err => {
        message.error("Gagal request reason no deal list");
      });
  }

  // ************************* Function Helper *************************//
  changeText(text) {
    switch (text) {
      case "MRP (Harga Max)":
        text = "Harga Final";
        break;
    }
    return text;
  }

  getValue(data, key, value) {
    let found;
    value = this.changeText(value);
    data = _.find(data, { [key]: value });
    if (data) {
      if (data.value) {
        found = data.value;
      } else if (data.price) {
        found = data.price;
      }
    }
    return found;
  }

  formatRupiah(number) {
    let data;
    if (number) {
      if (number !== "N/A") {
        data = `Rp.${number
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ".")},-`;
      } else {
        data = number;
      }
    } else {
      data = `Rp.0,-`;
    }
    return data;
  }

  // ************************* Function Open/Close Modal *************************//
  checkPermissionModal(type) {
    const { tradeIn, request } = this.state;
    let permission = true;
    const requestInProgress = _.find(request, { status: "Dalam Proses" });
    const objPermissionRequest = ["Discount", "MRP", "Deal", "No Deal"];
    const objPermissionFinish = ["Deal", "No Deal"];
    if (objPermissionRequest.includes(type)) {
      if (!tradeIn.NewCar) {
        permission = false;
        message.error("Pilih New Car Terlebih Dahulu");
      } else if (requestInProgress) {
        if (objPermissionFinish.includes(type)) {
          permission = false;
          message.error(
            `Request ${requestInProgress.status_label} Sedang Dalam Proses`
          );
        }
      }
    }
    return permission;
  }

  visibleModal(type, val) {
    const permission = this.checkPermissionModal(type);
    if (permission) {
      switch (type) {
        case "New Car":
          this.setState({ visibleModalNewCar: val });
          break;
        case "Discount":
        case "MRP":
          this.setState({ visibleModalRequest: val, typeRequest: type });
          break;
        case "Deal":
          this.setState({ visibleModalDeal: val });
          break;
        case "No Deal":
          this.setState({ visibleModalNoDeal: val });
          break;
        case "Appraisal Photo":
          this.setState({ visibleModalPhotoAppraisal: val });
          break;
      }
    }
  }

  // ************************* Function Modal New Car *************************//
  searchNewCar(e) {
    this.fetchNewCarList(e.target.value);
  }

  async changeNewCar(id) {
    const branchId = this.state.tradeIn.Appraisal.Booking.SalesProfile.branchId;
    const data = { newCarId: id, branchId };
    const idApproval = this.props.match.params.id;
    this.setState({ isLoading: true, search: "", visibleModalNewCar: false });
    try {
      await axios.put(`/approval/trade-in/new-car/${idApproval}`, data);
      message.success("Berhasil mengganti New Car");
      this.fetchTradeIn(idApproval);
    } catch (e) {
      this.setState({ isLoading: false });
      message.error("Gagal mengganti New Car");
    }
  }

  // ************************* Function Change Final Price Deal *************************//
  changeFinalPrice(price) {
    this.setState({ finalPrice: price });
  }

  // ************************* Function Modal Send Button *************************//

  async sendRequestButton(data, type) {
    type = type === "Discount" ? "discount" : "mrp";
    const idApproval = this.props.match.params.id;
    const branchId = this.state.tradeIn.Appraisal.Booking.SalesProfile.branchId;
    data = {
      ...data,
      branchId,
    };
    try {
      await axios.post(`/approval/trade-in/${idApproval}/${type}`, data);
      message.success("Success Request Trade In");
      this.fetchTradeIn(idApproval);
    } catch (e) {
      this.setState({ isLoading: false });
      message.error("Gagal Send Request");
    }
  }

  async sendDealButton(data) {
    try {
      data = {
        ...data,
        finalPrice: this.state.finalPrice,
      };
      const idApproval = this.props.match.params.id;
      await axios.put(`/approval/trade-in/finish/${idApproval}`, data);
      message.success("Success Finish Trade In");
      this.props.history.push(
        `/home/approval/trade-in-${this.props.location.query.status}`
      );
    } catch (e) {
      errorMessage(e.response || e);
    }
  }

  async sendNoDealButton(data) {
    try {
      const idApproval = this.props.match.params.id;
      await axios.put(`/approval/trade-in/finish/${idApproval}`, data);
      message.success("Success Finish Trade In");
      this.props.history.push(
        `/home/approval/trade-in-${this.props.location.query.status}`
      );
    } catch (e) {
      message.error("Gagal No Deal Trade In");
    }
  }

  isTrustCheck(approval) {
    let isTrust = true;

    let sourceOfRequest = _.get(approval, "Appraisal.Booking.sourceOfRequest");
    if (sourceOfRequest && sourceOfRequest === "MOBBI") {
      isTrust = false;
    }

    return isTrust;
  }

  render() {
    const { tradeIn, calculation, request } = this.state;
    const { Appraisal, NewCar } = tradeIn;
    const photoAppraisal = Appraisal
      ? Appraisal.finalPrice.linkKacab
        ? Appraisal.finalPrice.linkKacab
        : Appraisal.finalPrice.link
      : null;
    let isTrust = this.isTrustCheck(tradeIn);

    return tradeIn.id ? (
      <Card title="TRADE IN">
        <Spin size="large" spinning={this.state.isLoading} tip="Loading...">
          <div id="ApprovalTradeInDetail">
            <ApprovalInformation approval={tradeIn} approvalType="Trade In" />
            <Row>
              <CustomerInformation data={Appraisal} />
              <SalesInformation data={Appraisal} />
            </Row>

            <Row>
              <UsedCarInformation
                appraisal={Appraisal}
                getValue={this.getValue}
                visibleModal={this.visibleModal}
              />
              <NewCarInformation
                edit={true}
                newCar={NewCar}
                formatRupiah={this.formatRupiah}
                visibleModal={this.visibleModal}
              />
            </Row>

            <Row>
              <MobbiInformation tradeIn={tradeIn} isTrust={isTrust} />
            </Row>

            <Row>
              <RuangNego
                calculation={calculation}
                request={request}
                formatRupiah={this.formatRupiah}
                getValue={this.getValue}
                isTrust={isTrust}
              />
              <Discount
                approvalType="Trade In"
                calculation={calculation}
                request={request}
                formatRupiah={this.formatRupiah}
                getValue={this.getValue}
              />
            </Row>

            <Row>
              <GrossProfitAat
                calculation={calculation}
                finalPrice={this.state.finalPrice}
                formatRupiah={this.formatRupiah}
                getValue={this.getValue}
              />
              <RequestSection
                approvalType="Trade In"
                request={request}
                visibleModal={this.visibleModal}
              />
            </Row>
            <Row>
              <DealSection
                approvalType="Trade In"
                calculation={calculation}
                changeFinalPrice={this.changeFinalPrice}
                visibleModal={this.visibleModal}
                isTrust={isTrust}
              />
            </Row>

            <ModalNewCar
              data={this.state.newCarList}
              title="List New Car"
              visible={this.state.visibleModalNewCar}
              changeNewCar={this.changeNewCar}
              formatRupiah={this.formatRupiah}
              searchNewCar={this.searchNewCar}
              visibleModal={this.visibleModal}
            />

            <ModalRequest
              checkButtonSend={this.state.checkButtonSend}
              loadingButton={this.state.isLoadingButtonSend}
              title={this.state.typeRequest}
              visible={this.state.visibleModalRequest}
              formatRupiah={this.formatRupiah}
              sendButton={this.sendRequestButton}
              visibleModal={this.visibleModal}
            />

            <ModalDeal
              approvalType="Trade In"
              visible={this.state.visibleModalDeal}
              sendButton={this.sendDealButton}
              visibleModal={this.visibleModal}
            />
            <ModalNoDeal
              reason={this.state.reasonNoDealList}
              visible={this.state.visibleModalNoDeal}
              sendButton={this.sendNoDealButton}
              visibleModal={this.visibleModal}
            />

            {this.state.visibleModalPhotoAppraisal && (
              <Lightbox
                mainSrc={photoAppraisal}
                onCloseRequest={() =>
                  this.visibleModal("Appraisal Photo", false)
                }
              />
            )}
          </div>
        </Spin>
      </Card>
    ) : null;
  }
}
export default TradeInProgressDetail;



// WEBPACK FOOTER //
// src/components/Dashboard/Approval/TradeIn/InProgress/TradeInDetail.js